import "vite/modulepreload-polyfill";
import Alpine from "alpinejs";

// Dawn helpers that were previously loaded as separate <script defer> tags
// (constants.js, pubsub.js, global.js, animations.js). Import order matters:
// constants -> pubsub -> global -> animations.
// @ts-expect-error - JS module without types
import "../scripts/dawn/constants.js";
// @ts-expect-error - JS module without types
import "../scripts/dawn/pubsub.js";
// @ts-expect-error - JS module without types
import "../scripts/dawn/global.js";
// @ts-expect-error - JS module without types
import "../scripts/dawn/animations.js";

declare global {
  interface Window {
    Alpine: typeof Alpine;
  }
}

window.Alpine = Alpine;

Alpine.start();
